// 格式化sap时间 hhmmss -> hh:mm:ss
export const formatSapTime = (time) => {
  if (!time) return ''
  return time.replace(/^(\d{2})(\d{2})(\d{2})/, '$1:$2:$3')
}

// 格式化sap日期格式 yyyyMMdd -> yyyy-MM-dd
export const formatSapDate = (date, c = '-') => {
  if (!date) return ''
  return date.replace(/^(\d{4})(\d{2})(\d{2})/, `$1${c}$2${c}$3`)
}

// 格式化sap日期格式 yyyyMMddhhmmss -> yyyy-MM-dd hh:mm:ss
export const formatSapDateTime = (date, c = '-') => {
  if (!date) return ''
  return date.replace(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, `$1${c}$2${c}$3 $4:$5:$6`)
}

// 格式化文件大小 将 B 转换成 KB
export const formatSapFileSize = (size, pointLength, units = ['B', 'K', 'M', 'G', 'TB']) => {
  let unit = units || ['B', 'K', 'M', 'G', 'TB']

  while ((unit = units.shift()) && size > 1024) {
    size = size / 1024
  }
  return (unit === 'B' ? size : size.toFixed(pointLength || 2)) + unit
}

export const timeMixin = {
  methods: {
    formatSapTime,
    formatSapDate,
    formatSapFileSize
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js